function createSchema(schema) {
  return schema;
}
var t = createSchema;

export { createSchema, t };
